import { render, staticRenderFns } from "./wy-interactions-compare-metrics-cal-a.vue?vue&type=template&id=a9a5bd42&"
import script from "./wy-interactions-compare-metrics-cal-a.vue?vue&type=script&lang=js&"
export * from "./wy-interactions-compare-metrics-cal-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports